<template>
    <app-content class="h-panel">
        <div class="h-panel-bar">
            <span class="h-panel-title">内部转账</span>
        </div>
        <div class="margin-top margin-left filter-bar">
            <span class="label">日期：</span>
            <DatePicker v-model="p1" type="month" format="yyyy-MM"></DatePicker>
            <span class="label">至</span>
            <DatePicker v-model="p2" type="month" format="yyyy-MM"></DatePicker>
            <span class="label">转出账户：</span>
            <Select v-model="outAccountId" :datas="accountOptions" keyName="id" titleName="name"
                    :deletable="false" style="width:180px"></Select>
            <span class="label">转入账户：</span>
            <Select v-model="inAccountId" :datas="accountOptions" keyName="id" titleName="name"
                    :deletable="false" style="width:180px"></Select>
            <Button color="primary" size="s" @click="loadList">查询</Button>
            <Button size="s" @click="clearFilter">清除</Button>
            <span class="flex-spacer"></span>
            <Button color="primary" size="s" @click="add">新增</Button>
            <Button size="s" :disabled="!checkedList.length" @click="generateVoucher">生成凭证</Button>
            <Button size="s" :disabled="!checkedList.length" @click="batchRemove">批量删除</Button>
            <Button size="s" @click="exportCsv">导出</Button>
            <Button size="s" @click="printPage">打印</Button>
            <Button size="s" @click="showImport = true">导入</Button>
        </div>
        <div class="h-panel-body">
            <table class="grid">
                <thead>
                <tr>
                    <th style="width:44px"><input type="checkbox" :checked="checkAll" @click="toggleAll"></th>
                    <th style="width:110px">日期</th>
                    <th style="min-width:160px">摘要</th>
                    <th style="width:160px">转出账户</th>
                    <th style="width:160px">转入账户</th>
                    <th style="width:130px">金额</th>
                    <th style="min-width:140px">备注</th>
                    <th style="width:100px">关联凭证</th>
                    <th style="width:110px">操作</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="item in datas" :key="item.id">
                    <td align="center"><input type="checkbox" v-model="item._checked" :disabled="!!item.voucherId"></td>
                    <td>{{item.transferDate}}</td>
                    <td>{{item.summary}}</td>
                    <td>{{item.outAccountName}}</td>
                    <td>{{item.inAccountName}}</td>
                    <td align="right">{{item.amount|numFormat}}</td>
                    <td>{{item.remark}}</td>
                    <td class="text-hover">{{item.voucherWord}}{{item.voucherCode || ''}}</td>
                    <td class="actions">
                        <span @click="edit(item)">编辑</span>
                        <span @click="remove(item)">删除</span>
                    </td>
                </tr>
                <tr v-if="!datas.length">
                    <td colspan="9" class="text-center padding">暂无数据</td>
                </tr>
                <tr class="total">
                    <td colspan="5" align="center">人民币合计</td>
                    <td align="right">{{total|numFormat}}</td>
                    <td colspan="3"></td>
                </tr>
                </tbody>
            </table>
            <div class="padding-15 text-gray">
                提示：内部转账会自动生成转出、转入两笔日记账；按收支类别汇总时不计入收支。
            </div>
        </div>

        <Modal v-model="showForm" type="drawer-right" hasCloseIcon>
            <div slot="header">{{form.id ? '编辑' : '新增'}}转账</div>
            <Form ref="form" v-width="450" :labelWidth="110" :model="form" :rules="validationRules">
                <FormItem label="转账日期" prop="transferDate">
                    <DatePicker v-model="form.transferDate" format="yyyy-MM-dd"></DatePicker>
                </FormItem>
                <FormItem label="摘要"><textarea rows="2" v-model="form.summary"></textarea></FormItem>
                <FormItem label="转出账户" prop="outAccountId">
                    <Select v-model="form.outAccountId" :datas="realAccountOptions" keyName="id" titleName="name"
                            :deletable="false"></Select>
                </FormItem>
                <FormItem label="转入账户" prop="inAccountId">
                    <Select v-model="form.inAccountId" :datas="realAccountOptions" keyName="id" titleName="name"
                            :deletable="false"></Select>
                </FormItem>
                <FormItem label="转账金额(CNY)" prop="amount">
                    <NumberInput v-model="form.amount" :precision="2" :min="0"></NumberInput>
                </FormItem>
                <FormItem label="备注"><textarea rows="2" v-model="form.remark"></textarea></FormItem>
            </Form>
            <div class="text-center margin-top">
                <Button color="green" @click="submit(false)" :loading="loading">保存</Button>
                <Button color="primary" @click="submit(true)" :loading="loading" v-if="!form.id">保存并新增</Button>
                <Button @click="showForm=false">取消</Button>
            </div>
        </Modal>
        <import-modal v-model="showImport" title="内部转账导入" templateUrl="/api/cashier-transfer/template" :import-fn="importTransfer" @success="loadList"></import-modal>
    </app-content>
</template>

<script>
import ImportModal from '../../components/common/ImportModal';

const emptyForm = {
    id: null, transferDate: new Date(), summary: '', outAccountId: null,
    inAccountId: null, amount: 0, remark: ''
};

export default {
    name: 'CashierTransfer',
    components: { ImportModal },
    data() {
        const now = new Date();
        const ym = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
        return {
            datas: [],
            showImport: false,
            p1: ym,
            p2: ym,
            outAccountId: null,
            inAccountId: null,
            accounts: [],
            showForm: false,
            loading: false,
            form: Object.assign({}, emptyForm),
            validationRules: { required: ['transferDate', 'outAccountId', 'inAccountId', 'amount'] }
        };
    },
    computed: {
        accountOptions() {
            return [{ id: null, name: '所有账户' }].concat(this.accounts);
        },
        realAccountOptions() {
            return [{ id: null, name: '请选择' }].concat(this.accounts);
        },
        checkAll() {
            return this.datas.length > 0 && this.datas.every(d => d._checked);
        },
        checkedList() {
            return this.datas.filter(d => d._checked);
        },
        total() {
            return this.datas.reduce((s, d) => s + Number(d.amount || 0), 0);
        }
    },
    watch: {
        showForm(val) { if (!val) this.form = Object.assign({}, emptyForm); }
    },
    methods: {
        importTransfer(fd) {
            return this.$api.funds.transfer.importData(fd);
        },
        fmtPeriod(d) {
            if (!d) return '';
            if (typeof d === 'string') return d;
            return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
        },
        fmtDate(d) {
            if (!d) return '';
            if (typeof d === 'string') return d;
            return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
        },
        loadOptions() {
            this.$api.funds.journal.options().then(({ data }) => {
                this.accounts = data.accounts || [];
                this.loadList();
            });
        },
        loadList() {
            const params = { p1: this.fmtPeriod(this.p1), p2: this.fmtPeriod(this.p2) };
            if (this.outAccountId != null) params.outAccountId = this.outAccountId;
            if (this.inAccountId != null) params.inAccountId = this.inAccountId;
            this.$api.funds.transfer.list(params).then(({ data }) => {
                this.datas = (data || []).map(d => Object.assign({ _checked: false }, d));
            });
        },
        clearFilter() {
            this.outAccountId = null;
            this.inAccountId = null;
            this.loadList();
        },
        add() { this.form = Object.assign({}, emptyForm, { transferDate: new Date() }); this.showForm = true; },
        edit(item) {
            const f = Object.assign({}, emptyForm, item);
            f.transferDate = item.transferDate ? new Date(item.transferDate) : new Date();
            this.form = f;
            this.showForm = true;
        },
        submit(keepOpen) {
            if (!this.$refs.form.valid().result) return;
            if (this.form.outAccountId && this.form.outAccountId === this.form.inAccountId) {
                this.$Message.error('转出账户与转入账户不能相同');
                return;
            }
            const payload = Object.assign({}, this.form);
            payload.transferDate = this.fmtDate(payload.transferDate);
            this.loading = true;
            this.$api.funds.transfer[payload.id ? 'update' : 'save'](payload).then(() => {
                this.loading = false;
                this.loadList();
                this.$Message.success('保存成功');
                if (keepOpen) {
                    this.form = Object.assign({}, emptyForm, { transferDate: new Date() });
                } else {
                    this.showForm = false;
                }
            }).catch(() => { this.loading = false; });
        },
        remove(item) {
            this.$Confirm(`确认删除该笔转账记录?`).then(() => {
                this.$api.funds.transfer.delete(item.id).then(() => this.loadList());
            });
        },
        batchRemove() {
            const ids = this.checkedList.map(d => d.id);
            this.$Confirm(`确认删除选中的 ${ids.length} 笔转账?`).then(() => {
                this.$api.funds.transfer.batchDelete(ids).then(() => this.loadList());
            });
        },
        generateVoucher() {
            const ids = this.checkedList.map(d => d.id);
            this.$api.funds.transfer.generateVoucher(ids).then(({ msg }) => {
                this.$Message.success(msg || '已生成凭证');
                this.loadList();
            });
        },
        toggleAll() {
            const v = !this.checkAll;
            this.datas.forEach(d => { if (!d.voucherId) d._checked = v; });
        },
        exportCsv() {
            const head = ['日期', '摘要', '转出账户', '转入账户', '金额', '备注'];
            const rows = this.datas.map(d => [d.transferDate, d.summary, d.outAccountName, d.inAccountName, d.amount, d.remark]);
            rows.push(['人民币合计', '', '', '', this.total, '']);
            const csv = [head].concat(rows).map(r => r.map(c => `"${c == null ? '' : c}"`).join(',')).join('\r\n');
            this.download(`内部转账_${this.fmtPeriod(this.p1)}_${this.fmtPeriod(this.p2)}.csv`, '\ufeff' + csv);
        },
        download(name, content) {
            const blob = new Blob([content], { type: 'text/csv;charset=utf-8' });
            const a = document.createElement('a');
            a.href = URL.createObjectURL(blob);
            a.download = name;
            a.click();
            URL.revokeObjectURL(a.href);
        },
        printPage() { window.print(); },
        notOpen(name) { this.$Message.info(`${name}功能暂未开放`); }
    },
    mounted() {
        this.loadOptions();
    }
};
</script>

<style scoped lang="less">
    .filter-bar {
        display: flex;
        align-items: center;
        gap: 8px;
        flex-wrap: wrap;

        .label { margin-left: 6px; }
        .flex-spacer { flex: 1; }
    }

    .grid {
        width: 100%;
        border-collapse: collapse;
        margin-top: 10px;

        th, td {
            padding: 0 8px;
            border: 1px solid #e2e2e2;
            font-size: 12px;
            height: 32px;
            white-space: nowrap;
        }

        th {
            background-color: #f5f5f5;
            text-align: center;
            font-weight: bold;
            height: 35px;
        }

        tbody tr:nth-child(even) { background-color: #fafafa; }
        tbody tr:hover { background-color: #f0f6ff; }

        .total td { background-color: #f5f5f5; font-weight: bold; }
    }

    .actions span {
        margin-right: 8px;
        cursor: pointer;
        color: #3b91ff;
    }

    .text-hover { cursor: pointer; }
</style>
